import createIcon from '../../createIcon';

/**
 * @component @name Javascript
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuNSAxNFYxM0gxNFYxMy41SDE2VjEyLjVIMTMuNUMxMi45NSAxMi41IDEyLjUgMTIuMDUgMTIuNSAxMS41VjEwQzEyLjUgOS40NSAxMi45NSA5IDEzLjUgOUgxNi41QzE3LjA1IDkgMTcuNSA5LjQ1IDE3LjUgMTBWMTFIMTZWMTAuNUgxNFYxMS41SDE2LjVDMTcuMDUgMTEuNSAxNy41IDExLjk1IDE3LjUgMTIuNVYxNEMxNy41IDE0LjU1IDE3LjA1IDE1IDE2LjUgMTVIMTMuNUMxMi45NSAxNSAxMi41IDE0LjU1IDEyLjUgMTRaTTkuNSA5VjEzLjVIOFYxMi41SDYuNVYxMy41QzYuNSAxNC4zMyA3LjE3IDE1IDggMTVIOS41QzEwLjMzIDE1IDExIDE0LjMzIDExIDEzLjVWOUMxMSA5IDEwLjMzIDkgOS41IDlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Javascript = createIcon('Javascript', [
  [
    'path',
    {
      d: 'M12.5 14V13H14V13.5H16V12.5H13.5C12.95 12.5 12.5 12.05 12.5 11.5V10C12.5 9.45 12.95 9 13.5 9H16.5C17.05 9 17.5 9.45 17.5 10V11H16V10.5H14V11.5H16.5C17.05 11.5 17.5 11.95 17.5 12.5V14C17.5 14.55 17.05 15 16.5 15H13.5C12.95 15 12.5 14.55 12.5 14ZM9.5 9V13.5H8V12.5H6.5V13.5C6.5 14.33 7.17 15 8 15H9.5C10.33 15 11 14.33 11 13.5V9C11 9 10.33 9 9.5 9Z',
      key: '14a04i',
    },
  ],
]);

export default Javascript;
